import { Checkbox, FormControlLabel, Tooltip } from "@mui/material";
import { useContext, useState } from "react";
import { useRevalidator } from "react-router-dom";

import Colors from "../../../../global/Colors";
import DataContext from "../../../../../context/DataContext";
import LoadingIndicator from "../../../../global/LoadingIndicator";
import ResponseModal from "../../../../global/ResponseModal";
import useService from "../../../../../hooks/useService";
import ApiRequestErrorHandler from "../../../../global/ApiRequestErrorHandler";

export default function ApprovalChecklist({
  document,
}) {
  const documentRepository = useService('repositories/document-repository');
  const { userRoles } = useContext(DataContext);
  const [isLoading, setIsLoading] = useState(false);
  const [uploadSuccess, setUploadSuccess] = useState(false);
  const [uploadFailed, setUploadFailed] = useState(false);
  const [errorArray, setErrorArray] = useState([]);
  const { revalidate } = useRevalidator();

  const isDisabled = !userRoles.permissions.includes(
    "filemanager.add_documentapproval"
  );

  const updateItem = async (e) => {
    setIsLoading(true);
    try {
      const body = {
        [e.target.name]: e.target.checked,
      };

      if (e.target.name === "approved" && e.target.checked) {
        body.checked = true;
      }

      await documentRepository.patch(document.pk, body);
      setUploadSuccess(true);
      revalidate();
      setIsLoading(false);
    } catch (error) {
      setUploadFailed(true);
      setIsLoading(false);
      const errArr = ApiRequestErrorHandler(error ?? []);
      setErrorArray(errArr);
    }
  };

  const handleUploadSuccess = () => {
    setUploadSuccess(false);
  };

  return (
    <div className="flex flex-wrap">
      <FormControlLabel
        name="checked"
        disabled={isDisabled || document.approved}
        label={"Checked"}
        control={
          <Tooltip title="Set Document Checked">
            <Checkbox 
              disabled={isDisabled || document.approved} 
              checked={document.checked} 
              sx={{
                '&.MuiButtonBase-root.MuiCheckbox-root.Mui-checked.Mui-disabled': {
                  color: Colors.gray[400],
                },
              }}
            />
          </Tooltip>
        }
        onChange={(e) => updateItem(e)}
      />
      <FormControlLabel
        name="approved"
        disabled={isDisabled}
        label={"Approved"}
        control={
          <Tooltip title="Set Document Approved">
            <Checkbox
              checked={document.approved}
              sx={{
                '&.MuiButtonBase-root.MuiCheckbox-root.Mui-checked.Mui-disabled': {
                  color: Colors.gray[400],
                },
              }}  
            />
          </Tooltip>
        }
        onChange={(e) => updateItem(e)}
      />
      <LoadingIndicator isLoading={isLoading} />
      <ResponseModal
        title="Update Success"
        description="The image/document was successfully updated"
        openBool={uploadSuccess}
        setOpenBool={setUploadSuccess}
        handleCloseFunc={handleUploadSuccess}
      />
      <ResponseModal
        title="Update failed"
        isError={true}
        openBool={uploadFailed}
        setOpenBool={setUploadFailed}
        errorMessage={errorArray}
      />
    </div>
  );
}